import { injectable, inject } from 'inversify';
import Debug from 'debug';
import * as Commands from './commands'
import { DualCommandQueue }from '../../shared/dual-command-queue'

const debug = Debug('exam-result-service')

export const ExamResultServiceSymbol = Symbol.for('ExamResultService')

@injectable()
export class ExamResultService {

  private queue: DualCommandQueue;

  constructor(
    @inject(Commands.FinishExamAttemptCommandHandler)
    private finishExamCommand: Commands.FinishExamAttemptCommandHandler,
    @inject(Commands.QueryExamsTrackingStateCommandHandler)
    private queryTrackingStateCommand: Commands.QueryExamsTrackingStateCommandHandler) {
    
    this.queue = new DualCommandQueue('exam-result-service')
  }

  public start() {
    debug('starting ExamResultService');

    this.queue.start();
    this.queue.enqueueRemote('query-tracking-state', () => this.queryTrackingStateCommand.execute());
  }

  public async stop() {
    debug('stopping ExamResultService');

    await this.queue.stop()
  }

  public finishExam(payload: Commands.FinishExamCommandPayload) {
    this.queue.enqueueLocal('finish-exam', async () => {
      this.finishExamCommand.execute(payload)
    })
  }

}
